import React, { useContext } from "react";
import PhotobooksInformation from "./PhotobooksInformation";
import { PluginData } from "../../../pluginsInfrastructure/PluginRegistryTypes";
import TrackingUtil from "../../../utils/tracking";
import { ProductPageTabContext } from "../../../contexts/ProductPageTabContext";
import { scrollToTabs } from "../utils/photobooks";
import { PluginDataContext } from "../../../pluginsInfrastructure/PluginDataContextProvider";
import { PageStaticDataContext } from "../../../contexts/PageStaticDataContextProvider";

export type PhotobooksEditorDownloadProps = {};

const PhotobooksEditorDownload = (props: PhotobooksEditorDownloadProps) => {
  const { setSelectedTabId, setSelectedTabFocus } = useContext(ProductPageTabContext);
  const { pluginData } = useContext(PluginDataContext);
  const { mpv, tabData } = useContext(PageStaticDataContext);
  const { mpvId, name: productName, coreProductId } = mpv;
  const trackingFunc = TrackingUtil.sendTracking;

  const editorOptionsTabIndex = tabData.findIndex(tab => tab.type === "Editor Options");
  const onCompareEditorsClick = async (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (editorOptionsTabIndex) {
      event.preventDefault();
      await setSelectedTabId("tab-" + editorOptionsTabIndex);
      setSelectedTabFocus(true);
      scrollToTabs();
    }
  };

  return (
    <PhotobooksInformation
      offlineEditorMacDownload={pluginData.contentful.offlineEditorMacDownload}
      offlineEditorWindowsDownload={pluginData.contentful.offlineEditorWindowsDownload}
      compareEditors={pluginData.contentful.compareEditors || ""}
      designEditorDownloadInfo={pluginData.contentful.designEditorDownloadInfo || ""}
      mpvId={mpvId}
      productName={productName}
      coreProductId={coreProductId}
      onCompareEditorsClick={onCompareEditorsClick}
      trackingFunc={trackingFunc}
    />
  );
};

export default PhotobooksEditorDownload;
